export default __webpack_public_path__ + "static/media/sportsNutrition.672243a2.png";